import { useMutation } from "@tanstack/react-query";
import { apiClient } from "../service/tekkr-service";
import { useAuthController } from "../../auth/auth-provider";

interface Options {
    onSuccess?: (data: { orgId: string }) => void;
}

export function useAcceptInviteMutation(token: string, options?: Options) {
    const authController = useAuthController();
    return useMutation({
        mutationFn: async () => {
            const acceptResponse = await apiClient.acceptInvite({
                params: { token },
            });
            if (acceptResponse.status !== 200) {
                throw new Error("Failed to accept invite");
            }
            await authController.refetch();
            return { orgId: acceptResponse.body.orgId };
        },
        onSuccess: options?.onSuccess,
    });
}
